module.exports = __webpack_public_path__ + "img/arrow_next@2x.4efee12f.png";